import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { common } from "../../utils";
import { message, Modal } from "antd";
export class Cooperationalliance extends Component {
    state = {
        visible: false,
        Systen_Station_ID:"",
        codeTxt: "获取验证码",
        Name:"",
        Phone: "",
        PhoneCode:"",
    }
    static propTypes = {
        course: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
    };
    //弹出提示对话框
    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };
    //手机验证
    getCode() {
        //if (this.state.Phone.trim() === "") {
        //    message.warn("手机号码不能为空");
        //    return;
        //}
        if (common.checkPhone(this.state.Phone)) {
            let seconds = 60;
            this.setState({
                codeTxt: "发送中..."
            })
            this.props.actions.cooperationPhone({ Phone: this.state.Phone }).then(res => {
                if (res.SuccessResponse) {
                    message.success(res.Message);
                    let timer = setInterval(() => {
                        if (seconds > 0) {
                            this.setState({
                                codeTxt: `${seconds--}秒`
                            })
                        } else {
                            clearInterval(timer);
                            this.setState({
                                codeTxt: "获取验证码",
                            })
                        }
                    }, 1000)
                } else {
                    this.setState({
                        codeTxt: "获取验证码",
                    })
                }
            })
        } else {
            message.warn("请输入正确的手机号")
        }
    }
    componentWillMount() {
        let _this = this;
        this.props.actions.fetchGetConfiguration().then(res => {
            let data = res.data;
            if (data.SuccessResponse) {
                _this.setState({
                    Systen_Station_ID: data.Data.System_Station_ID
                })
            }
        });
    }
    //提交申请
    Submit = () => {
        console.log(this.state)
        if (this.state.Name === "") {
            message.warn("姓名能为空");
            return;
        }
        if (this.state.Phone === "") {
            message.warn("手机号码不能为空");
            return;
        } else if (!(/^1[3456789]\d{9}$/.test(this.state.Phone))) {
            message.warn("手机号码有误，请重填");
            return;
        }
        if (this.state.PhoneCode === "") {
            message.warn("验证码不能为空");
            return;
        }
        this.props.actions.getPhoneCodeIsTrue({ Phone: this.state.Phone, PhoneCode: this.state.PhoneCode }).then(str => {
            const _this = str.data.Data;
            if (_this) {
                this.props.actions.addClueByNetSchool({ Name: this.state.Name, Phone: this.state.Phone, System_Station_ID: this.state.Systen_Station_ID, SourceID: 221208, Remark: "合作联盟添加" }).then(res => {
                    if (res.data.Data) {
                        this.setState({
                            visible: true,
                        });
                    } else {
                        message.warn(res.data.Message);
                    }
                })
            } else {
                message.warn("验证码有误");
                return;
            }
        })
    }
    
    render() {
    const { codeTxt } = this.state;
    return (
      <div className="topic-cooperationalliance">
        <div className="header">
                <div className="header_box">
                    <div className="logo">
                    <img src={require('../../images/yx_logo.jpg')} />
                    <div className="logo_title">
                            <b>合作联盟</b>
                        <span>诚招加盟  互利共赢</span>
                    </div>
                </div>
                <div className="phone">客服热线: 17375813702</div>
            </div>
        </div>
         <div className="banner">
            <div className="banner_box">
                <div className="Verification">
                    <h1>在线教学  免费试用</h1>
                    <div className="Verification_box">
                            <div className="cont">
                                <input type="text" onChange={e => this.setState({ Name: e.target.value })} placeholder="请输入姓名" className="input" />
                        </div>
                            <div className="cont">
                                <input type="text" onChange={e => this.setState({ Phone: e.target.value })} placeholder="请输入手机号" className="input" />
                        </div>
                        <div className="cont">
                                <input type="text" onChange={e => this.setState({ PhoneCode: e.target.value })} placeholder="短信验证码" className="input input_tow" />
                                <span onClick={() => {
                                    if (codeTxt === "获取验证码") {
                                        this.getCode();
                                    }
                                }}>{codeTxt}
                                </span>
                            </div>
                            <div className="btn" onClick={this.Submit}>申请免费试用</div>
                    </div>
                        
                </div>
            </div> 
         </div>
            <div className="action">
                <div className="action_box1">
                    <div className="action_box1_cont">
                        <h1><span>"</span>前景收益<span>"</span></h1>
                        <div className="action_box1_title">在线教育“钱景”诱人，公认的朝阳行业</div>
                        <div className="guarantee">
                            <ul>
                                <li>
                                    <h2>行业现状</h2>
                                    <p>1. 2019年2月，中共中央、国务院印发《中国教育现代化2035》，明确提出加快推进智慧教育创新发展,构建“互联网+教育”支撑服务平台。</p>
                                </li>
                                <li>
                                    <h2>发展前景</h2>
                                    <p>1. 教育市场规模直逼3000亿。其中，在线教育占据约38%的市场份额，且这一数字还在不断增长。</p>
                                    <p>2. 智能化技术发展，在线教育逐渐走向管理化。网络教学+多媒体资源，高端品质促使中高端网校教育市场极具潜力。</p>
                                </li>
                                <li>
                                    <h2>合作收益</h2>
                                    <p>1. 平台化个性定制网校机构，全面增加网校课程开班率，优化网校资源。</p>
                                    <p>2. 在线全真模拟，以实务为驱动，体验真实网校，提高课程的单品质。</p>
                                    <p>3. 360°全方位运营服务，完整合作方案，有效协助机构提高招生转化率。</p>
                                    <p>4. 课程每年一更新，推出特色速成课程，形成差异化竞争力。</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="action_box2">
                    <div className="action_box2_cont">
                        <h1><span>"</span>合作门槛<span>"</span></h1>
                        <div className="action_box2_title">零经验办学，打造低成本创业新模式</div>
                        <div className="guarantee2">
                        </div>
                    </div>
                </div>
                <div className="action_box3">
                    <div className="action_box3_cont">
                        <h1><span>"</span>合作方案<span>"</span></h1>
                        <div className="action_box3_title">高质量的课程 + 领先的技术平台 + 专业的营销方案</div>
                        <div className="guarantee_three">
                            <ul className="ul">
                                <li className="li">
                                    <h2>网站建设</h2>
                                    <ul>
                                        <li>课程资源</li>
                                        <li>课程配置</li>
                                        <li>课程购买</li>
                                        <li>个人中心</li>
                                        <li>消息推送</li>
                                    </ul>

                                </li>
                                <li className="li">
                                    <h2>教学服务</h2>
                                    <ul>
                                        <li>题库</li>
                                        <li>讲义</li>
                                        <li>课程下载</li>
                                        <li>课程评论</li>
                                        <li>答疑</li>
                                    </ul>
                                </li>
                                <li className="li">
                                    <h2>教务管理</h2>
                                    <ul>
                                        <li>学籍管理</li>
                                        <li>教师管理</li>
                                        <li>学生录入</li>
                                        <li>书籍管理</li>
                                    </ul>
                                </li>
                                <li className="li">
                                    <h2>运营推广</h2>
                                    <ul>
                                        <li>课程售后</li>
                                        <li>客服培训</li>
                                        <li>活动推广</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="action_box4">
                    <div className="action_box4_cont">
                        <h1><span>"</span>综合服务<span>"</span></h1>
                        <div className="action_box4_title">致力于提供更好的产品与服务，打造自己的教育平台</div>
                        <div className="guarantee4">
                        </div>
                    </div>
                </div>
                <div className="action_box5">
                    <div className="action_box5_cont">
                        <div className="guarantee_five">
                            <h2>小程序移动端，把网校装进口袋</h2>
                            <p>更便捷的微信小程序网校，升级学习形式</p>
                            <ul>
                                <li>原生开发</li>
                                <li>在线购买</li>
                                <li>品牌及LOGO</li>
                                <li>学习记录</li>
                                <li>在线客服</li>
                                <li>多端同步</li>
                            </ul>
                            <div className="grarantee_bottom">
                                <span>小程序咨询</span>
                                <span>小程序试用</span>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="action_box6">
                    <div className="action_box6_cont">
                        <h1><span>"</span>加盟流程<span>"</span></h1>
                        <div className="action_box6_title">致力于提供更好的产品与服务，打造自己的教育平台</div>
                    </div>
                    <div className="guarantee_six">
                        <ul>
                            <li>了解加盟项目</li>
                            <li>到总部参观考察</li>
                            <li>签订合作协议</li>
                            <li>参加启动培训</li>
                            <li>持续扶持运营</li>
                        </ul>
                    </div>
                </div>
            </div>
            <Modal
                title="申请成功"
                centered={true}
                footer={null}
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >   
                <p>申请成功，请保持手机畅通，稍后会有客服人员跟您联系！谢谢您的关注！</p>
            </Modal>
      </div>
    );
  }
}
/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        course: state.course,
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cooperationalliance);




// WEBPACK FOOTER //
// ./src/features/topic/Cooperationalliance.js